import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export const renameKey = ( obj, oldKey, newKey ) =>{
    obj[newKey] = obj[oldKey];
    delete obj[oldKey];
  }
export const deleteKey = ( obj, oldKey ) => {
    delete obj[oldKey];
  }
  
const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

/**
 * Generic Excel export function that takes headers and data, and exports them into Excel.
 * @param {Array} headers - Array of objects defining the structure of the Excel file (header, key, width, autoFit, type).
 * @param {Array} apiData - Array of objects representing the data to export.
 * @param {String} fileName - The name of the Excel file to generate.
 * @param {String} author - The author of the Excel file.
 * @param {String} title - The title of the Excel file.
 */
export const exportToExcel = async (headers, apiData, filename, title = 'Excel Export') => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(title);

  // Add metadata to the workbook
  workbook.creator = 'DBT V2';
  workbook.title = title;
  workbook.created = new Date();
  workbook.modified = new Date();

  // Generate the current date and time for the filename
  const today = new Date();
  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const year = today.getFullYear();
  const hours = String(today.getHours()).padStart(2, '0');
  const minutes = String(today.getMinutes()).padStart(2, '0');
  const formattedDate = `${year}${month}${day}_${hours}${minutes}`;
  const fileName = `${filename}_${formattedDate}`;

  // Format the data according to the header type (without forcing Excel's format)
  const formattedData = apiData.map(obj => {
    let formattedObj = {};
    headers.forEach(header => {
      if (header.type === 'float') {
        formattedObj[header.key] = obj[header.key] ? parseFloat(obj[header.key]) : null;
      } else if (header.type === 'int') {
        formattedObj[header.key] = obj[header.key] ? parseInt(obj[header.key], 10) : null;
      } else if (header.type === 'date') {
        formattedObj[header.key] = obj[header.key] ? new Date(obj[header.key]) : null;
      } else {
        formattedObj[header.key] = obj[header.key];
      }
    });
    return formattedObj;
  });

  // Define columns in worksheet based on headers
  worksheet.columns = headers.map(col => ({
    header: col.header,
    key: col.key,
    width: col.autoFit ? undefined : col.width,
  }));

  // Style header: Bold
  worksheet.getRow(1).font = { bold: true };

  // Freeze the header row
  worksheet.views = [{ state: 'frozen', xSplit: 0, ySplit: 1, topLeftCell: 'A2', activeCell: 'A2' }];

  // Add autofilter to the columns
  worksheet.autoFilter = `A1:${String.fromCharCode(65 + headers.length - 1)}1`;

  // Add data rows
  formattedData.forEach(data => {
    worksheet.addRow(data);
  });

  // Autofit columns where autoFit is true
  worksheet.columns.forEach((column, index) => {
    if (headers[index].autoFit) {
      let maxColumnLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const columnLength = cell.value ? cell.value.toString().length : 10;
        if (columnLength > maxColumnLength) {
          maxColumnLength = columnLength;
        }
      });
      column.width = maxColumnLength < 10 ? 10 : maxColumnLength;
    }
  });

  // Generate Excel file in the browser
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: fileType });
  saveAs(blob, `${fileName}${fileExtension}`);
};